export default __webpack_public_path__ + "a57562bcb383eea63837155408f7ba7e.png";